import type { AdminMfaStatus } from './admin-access';

// Compatibility with older Cloud responses that counted a revoked method as configured.
export function normalizeAdminMfaStatus(status: AdminMfaStatus): AdminMfaStatus {
  const activeMethod = status.method?.status === 'ACTIVE' && !status.method.revokedAt ? status.method : null;
  return { ...status, configured: status.configured && Boolean(activeMethod), method: activeMethod };
}
